import { useEffect, useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { LuKeyRound } from 'react-icons/lu';
import { useAuth } from '@/features/auth/AuthProvider';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { BreadcrumbProvider } from './BreadcrumbContext';
import { cn } from '@/lib/cn';

const COLLAPSE_KEY = 'gem-tcms:sidebar-collapsed';

function readCollapsed() {
  try {
    return localStorage.getItem(COLLAPSE_KEY) === '1';
  } catch {
    return false;
  }
}

export function AppShell() {
  const [collapsed, setCollapsed] = useState(readCollapsed);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    try {
      localStorage.setItem(COLLAPSE_KEY, collapsed ? '1' : '0');
    } catch {
      /* storage unavailable — ignore */
    }
  }, [collapsed]);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo({ top: 0 });
  }, [pathname]);

  return (
    <BreadcrumbProvider>
      <div className="min-h-screen">
        <Sidebar collapsed={collapsed} onToggleCollapsed={() => setCollapsed((c) => !c)} mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />
        <div className={cn('flex min-h-screen flex-col transition-[padding] duration-200', collapsed ? 'lg:pl-16' : 'lg:pl-64')}>
          <Topbar onOpenMobileNav={() => setMobileOpen(true)} />
          <main className="mx-auto w-full max-w-[1600px] flex-1 px-4 py-5 lg:px-6 lg:py-6">
            {user?.mustChangePassword && (
              <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900" role="status">
                <span className="flex items-center gap-2"><LuKeyRound className="size-4" /> You signed in with a temporary password from your administrator. Please set your own password now.</span>
                {pathname !== '/account' && <Link to="/account" className="font-medium text-brand-800 underline">Change password</Link>}
              </div>
            )}
            <Outlet />
          </main>
        </div>
      </div>
    </BreadcrumbProvider>
  );
}
